import { useRef } from 'react';
import { Trans } from '@lingui/macro';
import { Text } from '@pocketlaw/tetris/deprecated';
import { FileUpload } from 'app/domains/upload';
import DropUpload from './DropUpload';
import { TextContainer, Container, StyledEmptyArtwork } from './styled';
function FileSystemEmpty(props) {
    const { folder, onDropUpload } = props;
    const fileUploadRef = useRef(null);
    const folderName = folder === null || folder === void 0 ? void 0 : folder.name;
    const handleFileChange = (event) => {
        const { files } = event.target;
        if (files) {
            const fileArray = Array.from(files);
            onDropUpload(fileArray);
        }
    };
    return (<Container>
      <DropUpload onDropUpload={onDropUpload}/>

      <StyledEmptyArtwork />

      <TextContainer>
        <Text appearance="neutral" weight="semibold" size="base">
          {folderName ? (<Trans>No folders or files in {folderName}</Trans>) : (<Trans>No folders or files</Trans>)}
        </Text>

        <Text appearance="neutral" size="base">
          <Trans>Upload your contracts &amp; documents to PocketLaw</Trans>
        </Text>
      </TextContainer>

      <FileUpload onChange={handleFileChange} ref={fileUploadRef} multiple/>
    </Container>);
}
export default FileSystemEmpty;
